import React from 'react';

import useStyles from './styles';

const Faqs = () => {
    return (
        <h1>Faqs</h1>
    )
}

export default Faqs;
